import React, { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-scroll";

import "./carousel.scss";
// import ym from "react-yandex-metrika";
import { breakLine } from "../../utils/newline";

import LeftArrow from "../../assets/images/carousel/LeftArrow";
import RightArrow from "../../assets/images/carousel/RightArrow";

function Carousel(props) {
  let [slideIndex, setSlideIndex] = useState(1);

  let slider = {};

  function next() {
    slider.slickNext();
  }

  function previous() {
    slider.slickPrev();
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current, next) => setSlideIndex((slideIndex = next + 1)),
  };

  const carouselContent = props.carouselContent;
  const arrowsPosition = props.arrowsPosition;

  const sendRoistatEvent = (link) => {
    if (link === 'salomCardForm') {
      // eslint-disable-next-line no-undef
      roistat.event.send('salom_website_btn_order_card');
    }
  };

  const carouselLayouts =
    carouselContent && carouselContent.length > 0 ? (
      carouselContent.map((content, index) => {
        return (
          <div key={index}>
            <div className="carousel-items" style={content.style}>
              <div className={content.template}>
                <div className="container">
                  <div className="carousel-description-content">
                    {content?.topText &&<p className="carousel-top-description" style={content.textStyle}>
                      {breakLine(content?.topText)}
                    </p>}
                    <h1
                      className="carousel-title"
                      style={content.titleStyle}
                    >
                      {breakLine(content.title)}
                    </h1>
                    <p className={content.container ? 'carousel-container' : 'd-none'}>
                      {breakLine(content.container)}
                    </p>
                    <p className="carousel-description" style={{...content.textStyle, ...content.bottomDescription}}>
                      {breakLine(content.text)}
                    </p>
                  </div>

                  <div className="carousel-image-content" style={content.img.style}>
                    {content.img.src && content.img.src.length > 0 ? (
                      <img
                        src={content.img.src}
                        className="slide-image"
                        alt="img"
                      />
                    ) : (
                        <></>
                      )}
                  </div>

                  {content.button.link ? (
                    <div className="carousel-button-content">
                      {content.button.isRouterLink ? (
                        <a
                          href={content.button.link}
                          className={"btn btn-success" + content.button.type}
                          style={content.button.style}
                        >
                          {content.button.value}
                        </a>
                      ) : (
                          <Link
                            className={"btn btn-success" + content.button.type}
                            style={content.button.style}
                            to={content.button.link}
                            smooth={true}
                            onClick={() => sendRoistatEvent(content.button.link)}
                          >
                            {content.button.value}
                          </Link>
                        )}
                    </div>
                  ) : (
                      <></>
                    )}

                  <div
                    className={
                      "custom-arrows d-flex justify-content-between bg-white " +
                      arrowsPosition
                    }
                  >
                    <button className="w-50" onClick={() => previous()}>
                      <LeftArrow />
                    </button>
                    <span className="d-flex align-items-center">
                      {slideIndex}
                      <span className="mx-1">/</span>
                      {carouselContent.length}
                    </span>
                    <button className="w-50" onClick={() => next()}>
                      <RightArrow />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
        <></>
      );

  return (
    <div className="Carousel">
      <Slider ref={(c) => (slider = c)} {...settings}>
        {carouselLayouts}
      </Slider>
    </div>
  );
}

export default Carousel;
